import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { DragulaService } from "ng2-dragula";
import { StorageService } from "src/app/services/storage.service";
import { BehaviorSubject } from "rxjs";
import { TimerService } from "src/app/services/timer.service";

@Component({
  selector: "app-secuencia",
  templateUrl: "./secuencia.component.html",
  styleUrls: ["./secuencia.component.scss"],
})
export class SecuenciaComponent implements OnInit {
  @Input() public DATA: any;
  @Input() public OPCIONES: any;
  @Input() public curso: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();

  //public parejaSubject: BehaviorSubject<any> = new BehaviorSubject(false);
  public parejaSubject: BehaviorSubject<any>;

  constructor(
    private dragulaService: DragulaService,
    private storageService: StorageService,
    private timerService: TimerService
  ) {}
  ordenarTipo: number;
  pareja: any = [];
  parejaText: any = [];
  host: string;
  private ID_TIPO = 4;
  private ID_ACTIVIDAD = 0;
  public activityCourse: any;
  public explicacion: string = "";
  ngOnInit() {
    this.name.emit("Secuencia");
    this.host = environment.host + "/";
    console.log("curso: ", this.curso);
    console.log("DATA: ", this.DATA);
    this.explicacion = this.DATA.explicacion;
    this.ID_ACTIVIDAD = this.DATA.id_actividad;
    this.ordenarTipo = this.DATA.tipo;
    let pareja: any = JSON.stringify(this.OPCIONES);
    let aux: string = JSON.stringify(this.OPCIONES);
    this.parejaText = JSON.parse(aux);

    this.pareja = this.shuffle(JSON.parse(pareja));
    this.parejaSubject = new BehaviorSubject(this.pareja);

    this.dragulaService.drag("bag3").subscribe(({ name, el, source }) => {
      //el.setAttribute('color', 'white');
      console.log("drag");
    });
    this.dragulaService.removeModel("bag3").subscribe(({ item }) => {
      console.log("removeModel");
    });

    this.dragulaService.dropModel("bag3").subscribe(({ name, el, source }) => {
      /* (async () => { 
          await this.delay(500);
          this.Storage(this.pareja);
          console.log("dropModel 2: ",this.pareja);
          this.parejaSubject.next(this.pareja);
        })(); */
    });
    this.getStorage();
    this.parejaSubject.subscribe((value) => {
      console.log("parejaSubject 1: True", value);
      console.log("parejaSubject 2: True", this.pareja);
    });
  }
  parejaChange() {
    this.parejaSubject.next(this.pareja);
    this.isvalid.emit(true);
    this.Storage(this.pareja);
  }
  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  shuffle(array) {
    let currentIndex = array.length,
      randomIndex;
    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }
    return array;
  }

  reorderItems(ev) {
    const item = this.pareja.splice(ev.detail.from, 1)[0];
    this.pareja.splice(ev.detail.to, 0, item);
    ev.detail.complete();
    console.log("Pareja: ", this.pareja);
    this.Storage(this.pareja);
  }
  getStorage() {
    let activityCourse: any;
    this.storageService.get("activities").then((res: any) => {
      if (res) {
        activityCourse = res.find(
          (x) =>
            x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
        );
        activityCourse.data.forEach((element2, j) => {
          if (
            element2.id == this.DATA.id &&
            element2.id_actividad == this.ID_ACTIVIDAD &&
            element2.id_tipo == this.ID_TIPO &&
            element2.tipo == 2
          ) {
            this.pareja = element2.respuesta.r;
            this.timerService.initTimer(element2.timer);
          }
        });

        this.Storage(this.pareja);
      }
    });
  }
  Storage(respuesta: any) {
    //console.log("Respuesta:",respuesta);
    /************************************* */
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.activityCourse = res;
          //let data:any = this.activityCourse.data;
          this.activityCourse.forEach((element, i) => {
            //console.log("DATA:",this.DATA.id_tipo);
            if (element.id == this.curso.id && element.id_actividad == this.ID_ACTIVIDAD) {
              let data: any;
              data = {
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                tipo: this.DATA.tipo,
                respuesta: {
                  r: respuesta,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            }
          });
          this.storageService.storage("activities", this.activityCourse);
        } else {
          let data: any;
          data = {
            id: this.DATA.id,
            id_actividad: this.DATA.id_actividad,
            id_tipo: this.DATA.id_tipo,
            tipo: this.DATA.tipo,
            respuesta: {
              r: respuesta,
            },
          };
          this.storageService.storage("activities", this.activityCourse);
        }
      })
      .catch((err) => {
        //this.storageService = null;
        console.log("storageService error", err);
      });
    /************************************* */
  }
}
